// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"00a3c656f913cd6ade98","678":"de22e0b67201aebe659c"}[chunkId] + ".js";
};